// import React, { useState } from "react";
// import Select from "react-select";
// import { Link } from "react-router-dom";

// const options = [
//     { value: "dashboard", label: "Dashboard" },
//     { value: "team", label: "My Team" },
//     { value: "buildings", label: "Buildings" },
//     { value: "reports", label: "Reports" },
// ];

// const properties = [
//     {
//         id: 1,
//         buildingName: "Office Complex A",
//         ownerName: "Alex Johns",
//         address: "123 Business St, City",
//         propertyType: "Office",
//         status: "Active",
//         periods: [
//             { from: "08/22/2022", to: "08/22/2023" },
//             { from: "09/01/2023", to: "09/01/2024" },
//             { from: "09/01/2023", to: "09/01/2024" },
//             { from: "09/01/2023", to: "09/01/2024" },
//         ],
//     },
//     {
//         id: 2,
//         buildingName: "Residential Tower B",
//         ownerName: "Sarah Lee",
//         address: "45 Park Ave, City",
//         propertyType: "Residential",
//         status: "Inactive",
//         periods: [
//             { from: "01/01/2021", to: "01/01/2022" },
//             { from: "02/01/2022", to: "02/01/2023" },
//         ],
//     },
//     {
//         id: 3,
//         buildingName: "Mall Center C",
//         ownerName: "Michael Smith",
//         address: "77 Downtown Rd, City",
//         propertyType: "Commercial",
//         status: "Active",
//         periods: [
//             { from: "03/15/2022", to: "03/15/2023" },
//             { from: "04/10/2023", to: "04/10/2024" },
//         ],
//     },
//     {
//         id: 4,
//         buildingName: "Office Complex A",
//         ownerName: "Alex Johns",
//         address: "123 Business St, City",
//         propertyType: "Office",
//         status: "Active",
//         periods: [
//             { from: "08/22/2022", to: "08/22/2023" },
//             { from: "09/01/2023", to: "09/01/2024" },
//             { from: "09/01/2023", to: "09/01/2024" },
//             { from: "09/01/2023", to: "09/01/2024" },
//         ],
//     },
//     {
//         id: 5,
//         buildingName: "Residential Tower B",
//         ownerName: "Sarah Lee",
//         address: "45 Park Ave, City",
//         propertyType: "Residential",
//         status: "Inactive",
//         periods: [
//             { from: "01/01/2021", to: "01/01/2022" },
//             { from: "02/01/2022", to: "02/01/2023" },
//         ],
//     },
//     {
//         id: 6,
//         buildingName: "Mall Center C",
//         ownerName: "Michael Smith",
//         address: "77 Downtown Rd, City",
//         propertyType: "Commercial",
//         status: "Active",
//         periods: [
//             { from: "03/15/2022", to: "03/15/2023" },
//             { from: "04/10/2023", to: "04/10/2024" },
//         ],
//     },
// ];

// const Buildings = () => {
//     const [selectedOption, setSelectedOption] = useState(null);

//     return (
//         <div className="admin-page">
//             <div className="admin-page-title d-flex align-items-center justify-content-between">
//                 <h1 className="page-section-title">Buildings</h1>
//                 <Link to="/buildings/create-building" className="btns">
//                     <i className="icon-icon-5"></i>
//                     Create Building
//                 </Link>
//             </div>

//             <div className="buildings-filter d-flex align-items-center">
//                 <div className="form-group mb-0">
//                     <label>Search</label>
//                     <div className="search-icon">
//                         <i className="icon-icon-6"></i>
//                         <input className="form-control" placeholder="Search buildings" />
//                     </div>
//                 </div>
//                 <div className="form-row d-flex">
//                     <div className="form-group mb-0">
//                         <label>Property Type</label>
//                         <div className="custom-select">
//                             <Select
//                                 options={options}
//                                 value={selectedOption}
//                                 onChange={setSelectedOption}
//                                 placeholder="All Types"
//                                 isClearable
//                             />
//                         </div>
//                     </div>
//                     <div className="form-group mb-0">
//                         <label>Status</label>
//                         <div className="custom-select">
//                             <Select
//                                 options={options}
//                                 value={selectedOption}
//                                 onChange={setSelectedOption}
//                                 placeholder="All Status"
//                                 isClearable
//                             />
//                         </div>
//                     </div>
//                 </div>
//             </div>
//             <div className="properties-listing">
//                 <h3 className="page-section-title mb-6">Properties Listing</h3>
//                 <div className="common-table">
//                     <div className="table-wrpper">
//                         <table>
//                             <thead>
//                                 <tr>
//                                     <th>Building Name</th>
//                                     <th>Owner Name</th>
//                                     <th>Address</th>
//                                     <th>Property Type</th>
//                                     <th>Status</th>
//                                     <th>Actions</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {properties.map((property) => (
//                                     <React.Fragment key={property.id}>
//                                         <tr>
//                                             <td>{property.buildingName}</td>
//                                             <td>{property.ownerName}</td>
//                                             <td>{property.address}</td>
//                                             <td>{property.propertyType}</td>
//                                             <td>
//                                                 <p className="status">{property.status}</p>
//                                             </td>
//                                             <td>
//                                                 <div className="d-flex button-group">
//                                                     <Link to="/buildings/building-details" className="btns-table view-btn">
//                                                         <i className="icon-icon-1"></i>
//                                                         View
//                                                     </Link>
//                                                     <Link to="/buildings/create-building" className="btns-table edit-btn">
//                                                         <i className="icon-icon-8"></i>
//                                                         Edit
//                                                     </Link>
//                                                 </div>
//                                             </td>
//                                         </tr>
//                                         <tr className="period-tr">
//                                             <td colSpan={6}>
//                                                 <div className="period-item d-flex">
//                                                     <p>Period</p>
//                                                     <ul className="d-flex align-items-center flex-wrap">
//                                                         {property.periods.map((period, idx) => (
//                                                             <li key={idx}>
//                                                                 <span>{period.from}</span> to{" "}
//                                                                 <span>{period.to}</span>
//                                                             </li>
//                                                         ))}
//                                                     </ul>
//                                                 </div>
//                                             </td>
//                                         </tr>
//                                     </React.Fragment>
//                                 ))}
//                             </tbody>
//                         </table>
//                     </div>
//                 </div>
//                 <div className="table-pagination d-flex align-items-center justify-content-between gap-2 mt-4">
//                     <div className="pagination-info">
//                         Showing 1 - 5 of 200                    </div>
//                     <div className="pagination-controls d-flex align-items-center">
//                         <button className="btns-table prev-btn"><i className="icon-icon-10"></i></button>
//                         <button className="btns-table next-btn" ><i className="icon-icon-9"></i></button>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// }

// export default Buildings;

import React, { useEffect, useState } from "react";
import Select from "react-select";
import { Link } from "react-router-dom";
import axios from "axios";

const propertyTypeOptions = [
  { value: "All", label: "All Types" },
  { value: "office", label: "Office" },
  { value: "retail", label: "Retail" },
  { value: "warehouse", label: "Warehouse" },
  { value: "residential", label: "Residential" },
];

const statusOptions = [
  { value: "All", label: "All Status" },
  { value: "Active", label: "Active" },
  { value: "Inactive", label: "Inactive" },
];

const Buildings = () => {
  const [buildings, setBuildings] = useState([]);
  const [search, setSearch] = useState("");
  const [propertyType, setPropertyType] = useState({ value: "All", label: "All Types" });
  const [status, setStatus] = useState({ value: "All", label: "All Status" });
  const [page, setPage] = useState(1);
  const [pageSize] = useState(10);
  const [pagination, setPagination] = useState({ total: 0, totalPages: 0 });

  // Fetch Buildings
  const fetchBuildings = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}building/list`, {
        headers: {
          "api-key": process.env.REACT_APP_API_KEY,
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        params: {
          page,
          pageSize,
          search,
          propertyType: propertyType?.value || "All",
          status: status?.value || "All",
        },
      });

      if (res.data.status === "success") {
        setBuildings(res.data.data.buildings);
        setPagination(res.data.data.pagination);
      } else {
        setBuildings([]);
      }
    } catch (err) {
      console.error("Error fetching buildings:", err);
    }
  };

  useEffect(() => {
    fetchBuildings();
  }, [page, search, propertyType, status]);

  // Delete Building Handler
  const handleDeleteBuilding = async (buildingId, buildingName) => {
    const confirmDelete = window.confirm(
      `Are you sure you want to delete "${buildingName}"?\n\nThis will permanently delete:\n• The building\n• All time periods\n• All imported data (costs, surfaces, consumptions)\n• All keys associated with this building\n\nThis action cannot be undone.`
    );

    if (!confirmDelete) return;

    try {
      const res = await axios.delete(`${process.env.REACT_APP_API_URL}building/delete/${buildingId}`, {
        headers: {
          "api-key": process.env.REACT_APP_API_KEY,
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      if (res.data.status === "success") {
        alert("Building deleted successfully!");
        fetchBuildings(); // Refresh the list
      } else {
        alert(res.data.message || "Failed to delete building");
      }
    } catch (err) {
      console.error("Error deleting building:", err);
      const errorMsg = err?.response?.data?.message || err?.response?.data?.data || "Failed to delete building";
      alert(errorMsg);
    }
  };

  return (
    <div className="admin-page">
      <div className="admin-page-title d-flex align-items-center justify-content-between">
        <h1 className="page-section-title">Buildings</h1>
        <Link to="/buildings/create-building" className="btns">
          <i className="icon-icon-5"></i>
          Create Building
        </Link>
      </div>

      {/* Filters */}
      <div className="buildings-filter d-flex align-items-center">
        <div className="form-group mb-0">
          <label>Search</label>
          <div className="search-icon">
            <i className="icon-icon-6"></i>
            <input
              className="form-control"
              placeholder="Search buildings"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
        </div>
        <div className="form-row d-flex">
          <div className="form-group mb-0">
            <label>Property Type</label>
            <div className="custom-select">
              <Select
                options={propertyTypeOptions}
                value={propertyType}
                onChange={setPropertyType}
                placeholder="All Types"
                isClearable
              />
            </div>
          </div>
          <div className="form-group mb-0">
            <label>Status</label>
            <div className="custom-select">
              <Select
                options={statusOptions}
                value={status}
                onChange={setStatus}
                placeholder="All Status"
                isClearable
              />
            </div>
          </div>
        </div>
      </div>

      {/* Table */}
      <div className="properties-listing">
        <h3 className="page-section-title mb-6">Properties Listing</h3>
        <div className="common-table">
          <div className="table-wrpper">
            <table>
              <thead>
                <tr>
                  <th>Building Name</th>
                  <th>Owner Name</th>
                  <th>Address</th>
                  <th>Property Type</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {buildings.map((building) => (
                    <React.Fragment key={building.id}>
                    <tr>
                        <td>{building.building_name}</td>
                        <td>{building.owner_name}</td>
                        <td>{building.building_address || building.property_address}</td>
                        <td>{building.property_type}</td>
                        <td>
                        <p className={`status ${building.is_active ? "active" : "inactive"}`}>
                            {building.status}
                        </p>
                        </td>
                        <td>
                        <div className="d-flex button-group">
                            <Link
                            to={`/buildings/building-details/${building.id}`}
                            className="btns-table view-btn"
                            >
                            <i className="icon-icon-1"></i>
                            View
                            </Link>
                            <Link
                            to={`/buildings/edit/${building.id}`}
                            className="btns-table edit-btn"
                            >
                            <i className="icon-icon-8"></i>
                            Edit
                            </Link>
                            <button
                            onClick={() => handleDeleteBuilding(building.id, building.building_name)}
                            className="btns-table delete-btn"
                            >
                            <i className="icon-icon-14"></i>
                            Delete
                            </button>
                        </div>
                        </td>
                    </tr>

                    {building.periods?.length > 0 && (
                        <tr className="period-tr">
                        <td colSpan={6}>
                            <div className="period-item d-flex">
                            <p>Period</p>
                            <ul className="d-flex align-items-center flex-wrap">
                                {building.periods.map((period) => (
                                <li key={period.id}>
                                    <span>{period.from}</span> to <span>{period.to}</span>
                                </li>
                                ))}
                            </ul>
                            </div>
                        </td>
                        </tr>
                    )}
                    </React.Fragment>
                ))}
                </tbody>
            </table>
          </div>
        </div>

        {/* Pagination */}
        <div className="table-pagination d-flex align-items-center justify-content-between gap-2 mt-4">
          <div className="pagination-info">
            Showing {(page - 1) * pageSize + 1} -{" "}
            {Math.min(page * pageSize, pagination.total)} of {pagination.total}
          </div>
          <div className="pagination-controls d-flex align-items-center">
            <button
              className="btns-table prev-btn"
              onClick={() => setPage((p) => Math.max(p - 1, 1))}
              disabled={page === 1}
            >
              <i className="icon-icon-10"></i>
            </button>
            <button
              className="btns-table next-btn"
              onClick={() => setPage((p) => Math.min(p + 1, pagination.totalPages))}
              disabled={page === pagination.totalPages}
            >
              <i className="icon-icon-9"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Buildings;